import {Vanity} from "../../parts/vanity";
import VanityCommon from "./vanityCommon";
import {createParentPositions, METADATA} from "../../constants";

export default class Mirror extends VanityCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'vanity_mirror';
    this.partName = 'Mirror';
    this.translateId = "visualizer.bathroom.vanity.vanity_mirror";
    this.homePageTitle = 'Mirrors';
    this.visible = [Vanity.Types.Complete, Vanity.Types.Custom];
    this.canBeDisabled = false;
    if (isChild) {
      createParentPositions(this);
    }
  }
  load(dbFeature) {
    if (Array.isArray(dbFeature.metaData["VanitySize"]) && dbFeature.metaData["VanitySize"][0] === "0") {
      dbFeature.metaData["VanitySize"] = [METADATA.ALL];
    }
    if (Array.isArray(dbFeature.metaData["MirrorShape"])) {
      if (dbFeature.metaData["MirrorShape"][0] === "00") {
        dbFeature.metaData["MirrorShape"] = [METADATA.ALL];
      }
      if (dbFeature.metaData["MirrorShape"][0]) {
        dbFeature.metaData["CustomMirrorShapeNoSize"] = dbFeature.metaData["MirrorShape"][0].split("X")[1];
      }
    }
    if (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"].includes("D")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    return super.load(dbFeature);
  }
}
